module.exports = __webpack_public_path__ + "img/Mstorybg1.0c01e809.jpg";